import { Extension } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    clipboard: {
      cut: () => ReturnType;
      copy: () => ReturnType;
      paste: () => ReturnType;
      pastePlain: () => ReturnType;
    };
    customExtension: {
      triggerCustomEvent: (data: any) => ReturnType;
    };
  }
}

interface CustomExtensionOptions {
  onCustomEvent?: (data: any) => void;
}

function getSelectedText(editor: any) {
  const { state } = editor;
  const { from, to } = state.selection;

  if (from === to) return true;

  const slice = state.doc.slice(from, to);
  return slice.content.textBetween(0, slice.content.size, '\n');
}

export const Clipboard = Extension.create<CustomExtensionOptions>({
  name: 'clipboard',

  addOptions() {
    return {
      onCustomEvent: () => {}
    };
  },

  addCommands() {
    return {
      cut:
        () =>
        ({ editor }) => {
          const text = getSelectedText(editor);

          navigator.clipboard
            .writeText(text)
            .then(() => {
              editor.chain().focus().deleteSelection().run();
            })
            .catch(err => {});

          return true;
        },
      copy:
        () =>
        ({ editor }) => {
          const text = getSelectedText(editor);

          navigator.clipboard.writeText(text).catch(err => {});

          return true;
        },
      paste:
        () =>
        ({ editor }: any) => {
          navigator.clipboard
            .read()
            .then(async items => {
              const textBlob = await items[0]?.getType('text/plain');
              const text = await textBlob?.text();
              const idx = editor.state.selection.from - 1;

              for (const item of items) {
                if (item.types.includes('text/html')) {
                  const blob = await item.getType('text/html');
                  const html = await blob.text();

                  editor.commands.insertContent(html);
                  setTimeout(() => this.options.onCustomEvent({ from: idx, to: editor.state.selection.from }));
                  return;
                }
              }

              if (text) {
                editor.commands.insertContent(text);
                setTimeout(() => this.options.onCustomEvent({ from: idx, to: editor.state.selection.from }));
              }
            })
            .catch(err => {});
          return true;
        },
      pastePlain:
        () =>
        ({ editor }: any) => {
          navigator.clipboard.readText().then(text => {
            if (text) {
              editor.commands.insertContent(text);
            }
          });
          return true;
        }
    };
  }
});
